export default __webpack_public_path__ + "static/media/listview.1a3b119d.svg";